export const OPTIONS_GET = 'OPTIONS_GET';
export const SETTINGS_GET = 'SETTINGS_GET';
export const FIELDS_EDIT = 'FIELDS_EDIT';
